import memeVotingContract, { MEME_VOTING_CONSTANTS } from '@/contracts/memeVoting';
import { MEME_GETTERS } from '@/store/meme';
import generalClient from '@/api/general';
import BLOCKCHAIN from "@/constants/blockchain";

export const VOTE_GETTERS = {
  TEMP: 'voteTemp',
  TEMP_NUTS: 'voteTempNuts',
  USER_REMAINING: 'voteUserRemaining',
};

export const VOTE_MUTATIONS = {
  TEMP: 'voteTemp',
  TEMP_NUTS: 'voteTempNuts',
  USER_REMAINING: 'voteUserRemaining',
  USER_REMAINING_REMOVE: 'voteUserRemainingRemove',
  REMOVE_TEMP: 'voteRemoveTemp',
};

export const VOTE_ACTIONS = {
  GET_USER_REMAINING: 'voteGetUserRemaining',
  ADD_TEMP: 'voteAddTemp',
}

export const voteStore = {
  state: () => ({
    temp: [],
    tempNuts: 0n,
    userRemaining: null,
  }),
  getters: {
    [VOTE_GETTERS.TEMP](state) {
      return state.temp;
    },
    [VOTE_GETTERS.TEMP_NUTS](state) {
      return state.tempNuts;
    },
    [VOTE_GETTERS.USER_REMAINING](state) {
      return state.userRemaining;
    },
  },
  mutations: {
    [VOTE_MUTATIONS.TEMP](state, temp) {
      state.temp = temp;
    },
    [VOTE_MUTATIONS.TEMP_NUTS](state, tempNuts) {
      state.tempNuts = tempNuts;
    },
    [VOTE_MUTATIONS.USER_REMAINING](state, userRemaining) {
      state.userRemaining = userRemaining;
    },
    [VOTE_MUTATIONS.USER_REMAINING_REMOVE](state) {
      state.userRemaining = state.userRemaining - state.temp.length;
    },
    [VOTE_MUTATIONS.REMOVE_TEMP](state, nonce) {
      const initialLength = state.temp.length;
      state.temp = state.temp.filter(n => n !== nonce);

      if (state.tempNuts > 0n) {
        const toRemove = BLOCKCHAIN.NUTS_PER_VOTE * BigInt((initialLength - state.temp.length));

        if (state.tempNuts > toRemove) {
          state.tempNuts -= toRemove;
        } else {
          state.tempNuts = 0n;
        }
      }
    },
  },
  actions: {
    async [VOTE_ACTIONS.GET_USER_REMAINING]({ commit, getters }, address) {
      const currentPeriod = getters[MEME_GETTERS.CURRENT_PERIOD];
      // eslint-disable-next-line prefer-const
      let { period, votes } = (await generalClient.addressVotes(address)) || {};

      if (currentPeriod !== period) {
        votes = MEME_VOTING_CONSTANTS.VOTES_PER_ADDRESS_PER_PERIOD;
      }

      commit(VOTE_MUTATIONS.USER_REMAINING, votes);
    },
    // TODO: Add somehow ability to swap egld to nuts
    [VOTE_ACTIONS.ADD_TEMP]({ commit, getters }, { nonce }) {
      const temp = getters[VOTE_GETTERS.TEMP];
      const tempNuts = getters[VOTE_GETTERS.TEMP_NUTS];

      // Limit votes to 20 because of contract limitations
      if (temp.length >= 20) {
        return false;
      }

      // If user doesn't have enough votes, increment tempNuts
      if (temp.length >= getters[VOTE_GETTERS.USER_REMAINING]) {
        commit(VOTE_MUTATIONS.TEMP_NUTS, tempNuts + BLOCKCHAIN.NUTS_PER_VOTE);
      }

      commit(VOTE_MUTATIONS.TEMP, [...temp, nonce].sort((a, b) => a - b));

      return true;
    },
  },
};
